import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, Moon, Sun, ChevronDown } from 'lucide-react'; // Added ChevronDown icon
import { useTheme } from 'next-themes';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { theme, setTheme } = useTheme();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path: string) => location.pathname === path;

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetId: string) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="bg-background border-b border-border shadow-sm py-4 sticky top-0 z-50">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2">
          <span className="text-2xl font-bold gradient-text text-left">KeepMore</span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-6">
          {/* <Link
            to="/"
            className={`relative h-10 flex items-center border-b-2 px-1 transition-colors ${
              isActive('/') ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground/80'
            }`}
          >
            <span className="text-left">Home</span>
          </Link>

          <a
            href="#features"
            onClick={(e) => handleSmoothScroll(e, 'features')}
            className="relative h-10 flex items-center border-b-2 px-1 transition-colors border-transparent text-muted-foreground hover:text-foreground/80"
          >
            <span className="text-left">Features</span>
          </a>

          <a
            href="#pricing"
            onClick={(e) => handleSmoothScroll(e, 'pricing')}
            className="relative h-10 flex items-center border-b-2 px-1 transition-colors border-transparent text-muted-foreground hover:text-foreground/80"
          >
            <span className="text-left">Pricing</span>
          </a> */}

          {location.pathname !== '/auth' && (
            <div className="flex items-center space-x-3">
              <Link to="/auth?mode=login">
                <Button variant="outline" className="font-medium">
                  Log In
                </Button>
              </Link>
              <Link to="/auth?mode=signup">
                <Button className="font-medium bg-primary hover:bg-primary/90">
                  Sign Up
                </Button>
              </Link>
            </div>
          )}
        </div>

        {/* Hamburger Button (Mobile Only) */}
        {location.pathname !== '/auth' && (
          <button className="md:hidden p-2 focus:outline-none z-50" onClick={toggleMenu} aria-label="Toggle Menu">
            {isOpen ? <X className="h-6 w-6 text-foreground" /> : <Menu className="h-6 w-6 text-foreground" />}
          </button>
        )}
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-background border-t border-border z-40 shadow-md transition-all duration-200 ease-in-out">
          <div className="px-4 py-4 flex flex-col space-y-4">
            {/* <a
              href="#features"
              onClick={(e) => {
                handleSmoothScroll(e, 'features');
                setIsOpen(false);
              }}
              className="py-2 transition-colors text-left text-muted-foreground hover:text-foreground/80"
            >
              Features
            </a>

            <a
              href="#features"
              onClick={(e) => {
                handleSmoothScroll(e, 'features');
                setIsOpen(false);
              }}
              className="py-2 transition-colors text-left text-muted-foreground hover:text-foreground/80"
            >
              Features
            </a>

            <a
              href="#pricing"
              onClick={(e) => {
                handleSmoothScroll(e, 'pricing');
                setIsOpen(false);
              }}
              className="py-2 transition-colors text-left text-muted-foreground hover:text-foreground/80"
            >
              Pricing
            </a> */}

          {location.pathname !== '/auth' &&   <div className="flex flex-col space-y-3 pt-2">
              <Link to="/auth?mode=login" onClick={() => setIsOpen(false)}>
                <Button variant="outline" className="w-full font-medium text-left">
                  Log In
                </Button>
              </Link>
              <Link to="/auth?mode=signup" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-primary hover:bg-primary/90 font-medium text-left">
                  Sign Up
                </Button>
              </Link>
            </div>}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
